(() => {
  const scopeSelector = '[data-accessory-view-scope]';
  const storageKey = (scope) => `alu-accessory-view:${scope.dataset.accessoryViewKey || ''}`;
  const validView = (value) => value === 'list' ? 'list' : 'grid';

  const apply = (scope, view) => {
    const mode = validView(view);
    scope.dataset.accessoryView = mode;
    scope.querySelectorAll('[data-accessory-view-items]').forEach((items) => {
      items.dataset.accessoryView = mode;
      if (items.matches('.new-grid')) items.dataset.view = mode === 'list' ? 'list' : 'medium';
    });
    scope.querySelectorAll('.accessory-catalog__list .accessory-row__image img').forEach((image) => {
      image.sizes = mode === 'grid'
        ? '(min-width: 1024px) 45vw, (min-width: 391px) 45vw, calc(100vw - 34px)'
        : '90px';
    });
    scope.querySelectorAll('[data-accessory-view-option]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.accessoryViewOption === mode));
    });
  };

  const initialize = (scope) => {
    if (scope.dataset.accessoryViewReady === 'true') return;
    scope.dataset.accessoryViewReady = 'true';
    let saved = '';
    try { saved = localStorage.getItem(storageKey(scope)) || ''; } catch (_) {}
    apply(scope, saved || scope.dataset.accessoryViewDefault || 'grid');
  };

  const scan = (node = document) => {
    if (node.matches?.(scopeSelector)) initialize(node);
    node.querySelectorAll?.(scopeSelector).forEach(initialize);
    const owner = node.closest?.(scopeSelector);
    if (owner?.dataset.accessoryViewReady === 'true') apply(owner, owner.dataset.accessoryView || owner.dataset.accessoryViewDefault);
  };

  document.addEventListener('DOMContentLoaded', () => scan());
  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-accessory-view-option]');
    if (!button) return;
    const scope = button.closest(scopeSelector);
    if (!scope) return;
    event.preventDefault();
    const view = validView(button.dataset.accessoryViewOption);
    apply(scope, view);
    try { localStorage.setItem(storageKey(scope), view); } catch (_) {}
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-adjust]');
    if (!button) return;
    const form = button.closest('form');
    const input = form?.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Math.max(1, Number.parseInt(input.value, 10) || 1);
    input.value = String(Math.max(Number(input.min) || 1, current + Number(button.dataset.quantityAdjust)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const bindCartForms = (node = document) => {
    if (!window.theme?.AjaxProduct) return;
    const forms = [];
    if (node.matches?.('[data-accessory-cart-form]')) forms.push(node);
    node.querySelectorAll?.('[data-accessory-cart-form]').forEach((form) => forms.push(form));
    forms.forEach((form) => {
      if (form.dataset.accessoryCartReady === 'true') return;
      form.dataset.accessoryCartReady = 'true';
      new window.theme.AjaxProduct(form, '.add-to-cart');
    });
  };
  bindCartForms();
  document.addEventListener('DOMContentLoaded', () => bindCartForms());
  document.addEventListener('shopify:section:load', (event) => bindCartForms(event.target));

  let queued = false;
  new MutationObserver((records) => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { scan(node); bindCartForms(node); }
      }));
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
